import { buttonStyles } from "@/components/ui/button.tsx";
import { ModalClose, ModalContent, ModalDescription, ModalFooter, ModalHeader, ModalTitle } from "@/components/ui/modal.tsx";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import { useCallback } from "react";

export interface LegacyRedirectModalProps {
    isOpen: boolean;
    onOpenChange: (isOpen: boolean) => void;
    eyebrow: string;
    title: string;
    body: string;
    cancelLabel: string;
    continueLabel: string;
    continueHref: string;
}

export function LegacyRedirectModal({ isOpen, onOpenChange, eyebrow, title, body, cancelLabel, continueLabel, continueHref }: LegacyRedirectModalProps) {
    const handleContinue = useCallback(() => onOpenChange(false), [onOpenChange]);

    return (
        <ModalContent isOpen={isOpen} onOpenChange={onOpenChange} size="md" closeButton={false} className="rounded-t-3xl sm:rounded-3xl">
            <ModalHeader className="space-y-0 p-8 text-center">
                <span className="text-muted-fg mb-4 block text-[0.6875rem] font-semibold tracking-[0.09625rem] uppercase">{eyebrow}</span>
                <ModalTitle level={2} className="text-xl leading-tight tracking-tight sm:text-xl">
                    {title}
                </ModalTitle>
                <ModalDescription className="mt-4 text-base leading-relaxed sm:text-base">{body}</ModalDescription>
            </ModalHeader>

            <ModalFooter className="flex-row flex-wrap items-center justify-center gap-3 px-8 pt-0 pb-8">
                <ModalClose intent="outline" className="h-10 !px-5">
                    {cancelLabel}
                </ModalClose>
                <a href={continueHref} target="_blank" rel="noopener noreferrer" onClick={handleContinue} className={`${buttonStyles({ intent: "primary" })} h-10 !px-5`}>
                    {continueLabel}
                    <ArrowTopRightOnSquareIcon className="size-4" aria-hidden="true" />
                </a>
            </ModalFooter>
        </ModalContent>
    );
}
